import { gql } from '@apollo/client';

export const CREATE_BLOG_POST_LOCALIZATION_MUTATION = gql`
  mutation CreateBlogPostLocalization($data: updateBlogPostInput!) {
    createBlogPostLocalization(input: $data) {
      id
    }
  }
`;
